import type { CSSProperties } from "react"

const T = {
  bg:     "#0a0a0f",
  accent: "#7c6af7",
}

const LoadingScreen = () => (
    <div style={s.wrapper}>
      <style>{css}</style>
      {[0, 0.15, 0.3].map((delay, i) => (
        <div key={i} style={{ ...s.dot, animationDelay: `${delay}s` }} />
      ))}
    </div>
  )

const s: Record<string, CSSProperties> = {
  wrapper: {
    display:        "flex",
    gap:            8,
    alignItems:     "center",
    justifyContent: "center",
    padding:        80,
    background:     T.bg,
    minHeight:      "100vh",
  },
  dot: {
    width:        8,
    height:       8,
    borderRadius: "50%",
    background:   T.accent,
    animation:    "pulse 0.9s ease-in-out infinite",
  },
}

const css = `
  @keyframes pulse {
    0%, 100% { opacity: 0.2; transform: scale(0.8); }
    50%       { opacity: 1;   transform: scale(1);   }
  }
`

export default LoadingScreen